import { cn } from "@/lib/utils";
import { useTheme } from "@/lib/theme";

/**
 * Official refined YA TÚ SABES PR lockup. Use the user's artwork rather than
 * approximating the custom letters with browser fonts.
 *
 * Transparent light and dark variants preserve the Puerto Rican flag PR motif
 * and the tagline; all header, menu, footer and detail views share this file.
 */
const LIGHT_LOGO = "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/f83bf12b0_yts-logo-editorial-light.png";
const DARK_LOGO = "https://media.base44.com/images/public/6ab7c499b9f1892aef65dca6/6f769c66a_yts-logo-editorial-dark.png";

const SIZES = {
  header: "w-[218px] max-w-full",
  footer: "w-[262px] max-w-full",
  chrome: "w-[184px] max-w-full",
};

export default function BrandMark({ variant = "header", className = "", forceDark = false }) {
  const { isDark } = useTheme();
  return (
    <img
      src={forceDark || isDark ? DARK_LOGO : LIGHT_LOGO}
      width={1317}
      height={329}
      alt="YA TÚ SABES PR — Puerto Rico's Local Guide"
      loading="eager"
      decoding="async"
      draggable={false}
      className={cn(
        "yts-brand-image block h-auto shrink-0 select-none object-contain",
        SIZES[variant] || SIZES.header,
        className
      )}
    />
  );
}